<div class="PGVisitCardConfirm">
    <h2>{{ 'pg-visit-card-confirm.title' | locTranslate }}</h2>
    <div class="d-flex justify-content-between">
        <button class="btn btn-primary btn-sm" (click)="createVisitCardModalOpen()">
            <i class="fa-regular fa-plus"></i>
            <span>{{ 'pg-visit-card-confirm.visit-card-create' | locTranslate }}</span>
        </button>

        <button class="btn btn-primary btn-sm" [disabled]="isLoading" (click)="reset()">
            <i class="fa-regular fa-arrows-rotate"></i>
            <span>{{ 'pg-visit-card-confirm.visit-card-check-requests' | locTranslate }}</span>
        </button>
    </div>
    <table class="table mt-3">
        <thead>
            <tr>
                @if(resourceMode == 'data') {
                    <th class="bg-light">{{ 'pg-visit-card-confirm.visit-card-supplier' | locTranslate }}</th>
                }
                <th class="bg-light">{{ 'pg-visit-card-confirm.visit-card-code' | locTranslate }}</th>
                <th class="bg-light">{{ 'pg-visit-card-confirm.visit-card-from' | locTranslate }}</th>
                <th class="bg-light">{{ 'pg-visit-card-confirm.visit-card-to' | locTranslate }}</th>
                <th class="bg-light">{{ 'pg-visit-card-confirm.visit-card-status' | locTranslate }}</th>
                <th class="bg-light"></th>
                <th class="bg-light"></th>
            </tr>
        </thead>
        <tbody>
            @for (request of visitCardData; track request) {
                <tr>
                    @if(resourceMode == 'data') {
                        <td>
                            {{ supplierData[request.supplier]?.name }}
                        </td>
                    }
                    <td>
                        <span class="font-monospace">{{ request.code }}</span>
                    </td>
                    <td>{{ request.from | locFormat:'date' }}</td>
                    <td>{{ request.to | locFormat:'date' }}</td>
                    <td>
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                {{ 'pg-visit-card-confirm.visit-card-status-' + request.status | locTranslate }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-center">
                            @if(request.status == 'confirmed') {
                                <button  class="btn btn-link" (click)="showVisitCardModalOpen(request)">
                                    <i class="fa-regular fa-id-card fa-fw"></i>
                                    <span>{{ 'pg-visit-card-confirm.visit-card-show' | locTranslate }}</span>
                                </button>
                            }
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-end align-items-center">
                            @if(request.backoffice_created) {
                                <div class="me-5 text-muted">
                                    <i class="fa-regular fa-certificate fa-lg" title="{{ 'pg-visit-card-confirm.visit-card-backoffice-created' | locTranslate }}"></i>
                                </div>
                            }

                            <button class="btn btn-sm btn-{{ request.status === 'pending' || request.status === 'confirmed' ? 'success' : 'secondary' }}" [class.pe-none]="request.status == 'confirmed'" [disabled]="isSettingVisitCardStatus[request.id]" (click)="setVisitCardStatus(request, 'accept')">
                                <i class="fa-regular fa-check fa-fw"></i>
                            </button>
                            <app-pg-confirm-action [disabled]="request.status == 'canceled' || isSettingVisitCardStatus[request.id]" (confirmed)="setVisitCardStatus(request, 'refuse')">
                                <button class="ms-2 btn btn-sm btn-{{ request.status == 'pending' || request.status == 'canceled' ? 'danger' : 'secondary' }}" [class.pe-none]="request.status == 'canceled'" [disabled]="isSettingVisitCardStatus[request.id]">
                                    <i class="fa-regular fa-times fa-fw"></i>
                                </button>
                            </app-pg-confirm-action>
                        </div>
                    </td>
                </tr>
            }
        </tbody>
    </table>
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    <app-pg-view-more [hidden]="isLoading || isAtEnd" (viewMore)="loadData()"></app-pg-view-more>
</div>

<ng-template #showVisitCardModal>
        <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-visit-card-confirm.visit-card-show-modal-title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="showVisitCardModalDismiss()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="rounded shadow-sm">
            <app-visit-card-image [visitCardStatus]="showVisitCardModalRequest" (isReady)="showVisitCardModalIsReady = true"></app-visit-card-image>
        </div>
    </div>
    @if(showVisitCardModalIsReady) {
        <div class="modal-footer justify-content-between">
            <button class="btn btn-primary" (click)="showVisitCardModalDownloadImage()">
                <i class="fa-regular fa-download"></i>
                <span>{{ 'pg-visit-card-confirm.visit-card-show-modal-download-image' | locTranslate }}</span>
            </button>
    
            <div class="d-flex">
                @if(showVisitCardModalRequest.backoffice_created) {
                    <div class="me-2">
                        <app-pg-recipient [(ngModel)]="showVisitCardModalContactRecipient" (viaChange)="showVisitCardModalContactVia = $event;"></app-pg-recipient>
                    </div>
                }
        
                <button class="btn btn-primary" [disabled]="(showVisitCardModalRequest.backoffice_created && showVisitCardModalContactVia == null) || showVisitCardModalIsSending" (click)="showVisitCardModalSendImage()">
                    <i class="fa-regular fa-paper-plane"></i>
                    <span>{{ 'pg-visit-card-confirm.visit-card-show-modal-send-image' | locTranslate }}</span>
                </button>
            </div>
        </div>
    }
</ng-template>

<ng-template #createVisitCardModal>
        <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-visit-card-confirm.visit-card-create-modal-title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="createVisitCardModalDismiss()">
            <i class="fa-regular fa-times"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label><b>{{ 'pg-visit-card-confirm.visit-card-create-modal-element' | locTranslate }}</b></label>

            <app-pg-select [resource]="createVisitCardResource" [resourceMode]="createVisitCardResourceMode" display="oneLine" [(ngModel)]="createVisitCardElement" [required]="true" 
                [optionsFilter]="createVisitCardResourceFilter" [optionsOrder]="createVisitCardResourceOrder"
                [resourceSemantic]="createVisitCardResourceSemantic" requiredAutoSelect="single" [readonly]="createVisitCardModalIsSaving"></app-pg-select>
        </div>

        <div class="form-group">
            <label><b>{{ 'pg-visit-card-confirm.visit-card-create-modal-from' | locTranslate }}</b></label>

            <input type="date" class="form-control" [(ngModel)]="createVisitCardFrom" [disabled]="true"/>
        </div>

        <div class="form-group">
            <label><b>{{ 'pg-visit-card-confirm.visit-card-create-modal-to' | locTranslate }}</b></label>

            <input type="date" class="form-control" [(ngModel)]="createVisitCardTo" [disabled]="createVisitCardModalIsSaving"/>
        </div>
    </div>
    <div class="modal-footer justify-content-center">
        <button class="btn btn-primary" [disabled]="createVisitCardModalIsSaving || !createVisitCardElement || !createVisitCardFrom || !createVisitCardTo" (click)="createVisitCardModalSubmit()">
            <i class="fa-regular fa-plus"></i>
            <span>{{ 'pg-visit-card-confirm.visit-card-create-modal-submit' | locTranslate }}</span>
        </button>
    </div>
</ng-template>